<template>
  <v-container class="text-center">
    <v-layout row justify-space-around>
      <v-flex xs12 sm7 md5 lg4 xl3 class="text-xs-center">
        <v-card outlined class="pa-5 text-center">
          <h1 class="py-3 mb-3 title text-center blue--text">Create Omentum Account</h1>
            <p>In order to secure our platform, please create an account to access the content.</p>
            <v-row>
              <v-col>
                <v-text-field outlined required v-model="firstname" label="First Name"></v-text-field>
              </v-col>
              <v-col>
                <v-text-field outlined  v-model="lastname" label="Last Name"></v-text-field>
              </v-col>
            </v-row>

            <span class="blue--text text--darken-2 overline"><strong>Use your School email to access all content.</strong></span>
            <v-text-field outlined v-model="email" label="Email"></v-text-field>

            <v-text-field outlined v-model="password" label="Password" type="password"></v-text-field>
            <v-text-field outlined v-model="passwordCheck" label="Password Again" type="password"></v-text-field>
            <div>
              <v-select outlined v-model="cohort" :items="cohortOptions" item-text="text" item-value="value" label="Cohort"></v-select>
            </div>
            <div class="pb-3">
              <v-switch color="blue" v-model="tos" class="d-inline-block pb-0"></v-switch>
              I agree to Omentum's <a href="/tou" target="_blank">Terms of Use</a>.
            </div>
            <v-btn v-if="validEntry" large rounded :loading="loading" color="blue" dark @click="createUser">Sign Up</v-btn>
            <v-btn v-if="!validEntry" disabled large rounded >Sign Up</v-btn>
            <p v-if="error" class="red--text pt-5">{{error}}</p>
          </v-form>
        </v-card>
        </v-flex>
      </v-layout>

  </v-container>

</template>

<script>
import firebase from 'firebase'
import moment from 'moment'
import db from '@/fb'
export default {
  name: 'SignUp',
  data() {
    return {
      firstname: "",
      lastname: "",
      email: "",
      password: "",
      passwordCheck: "",
      tos: false,
      loading: false,
      error: null,
      tag: null,
      cohort: null,
      cohortOptions: [
        {text: 'Other', value: 'other'},
      ]
    }
  },
  mounted() {
    if (this.$route.params.tag) {
      this.tag = this.$route.params.tag
    }
    //set cohort options
    
    let month = moment().get('month')
    let year = moment().get('year')
    month >= 5 ? year += 1 : year
    let cohorts = []
    cohorts.push({text: 'Other', value: 'other'})
    cohorts.push({text: 'Davis IM Resident', value: 'ucdIMresident'})
    for (let i = 0; i < 4; i++) {
      cohorts.push({text: 'Davis Med Student Class ' + (year + i), value: 'ucd' + (year + i)})
    }
    this.cohortOptions = cohorts.reverse()


  },
  computed: {
    validEntry() {
      if (this.firstname.length > 0
        && this.lastname.length > 0
        && this.email.length > 0
        && this.password.length > 0
        && this.passwordCheck.length > 0
        && this.cohort != null
        && this.tos) {
          return true
        }
        else {
          return false
        }
    }
  },
  methods: {
    displayName() {
      console.log(firebase.auth().currentUser.displayName)
    },
    createUser() {
      this.error = null

      if (this.password == this.passwordCheck) {
        this.loading = true
        firebase.auth().createUserWithEmailAndPassword(this.email, this.password)
        .then(result => {
          let user = firebase.auth().currentUser
          user.updateProfile({
            displayName: this.firstname + " " + this.lastname
          })

        })
        .catch(err => {
          this.error = err
          this.loading = false
          console.log(err)
        })
        .then(() => {
          let userData = {
            uid: firebase.auth().currentUser.uid,
            created: new Date(),
            firstname: this.firstname,
            lastname: this.lastname,
            email: this.email.toLowerCase(),
            subscribedDecks: [],
            cohorts: [this.cohort],
            domainAuth:[this.email.toLowerCase().split('@')[1]],
            tos: true,
            tosTime: new Date()
          }
          return firebase.firestore().collection('users')
          .doc(firebase.auth().currentUser.uid)
          .set(userData)
        })
        .then(() => {
          this.loading = false
          this.$router.push({ name: "EmailVerify"})
        })
      }
      else {
        this.error = "Check your password"
      }
    }
  }
}
</script>

<style>

</style>
